import { Injectable } from "@angular/core";
import { ServiciosRiegosService } from "../../../services/riesgo-liquidez/servicios-riegos.service";

@Injectable({
  providedIn: 'root'
})
export class ConsultasService{
  constructor(
    private readonly service: ServiciosRiegosService,
  ){}

  async getDetalleCuenta(
    idCuenta: string,
    evaluacion: number
  ){
    try{
      const response = await this.service.getDetalleCuenta(evaluacion, idCuenta);
      return response.detalleEvaluacionCuenta.valor??0;
    }catch(err){
      return 0;
    }
  }
  async getCuenta(
    idCuenta: string,
    idPlantilla: number
  ){
    try{
      const response = await this.service.getCuenta(idCuenta, idPlantilla);
      return response.cuenta.descripcion??'';
    }catch(err){
      return '';
    }
  }

  async getDetalleVariableTemp(
    idCuenta: string,
    evaluacion: number
  ){
    try{
      const response = await this.service.getDetalleVarTemp(evaluacion, idCuenta);
      return response.detalleEvaluacionVarTemp.valor??0;
    }catch(err){
      return 0;
    }
  }
  async getVariableTemp(
    idCuenta: string,
    idPlantilla: number
  ){
    try{
      const response = await this.service.getVarTemp(idCuenta, idPlantilla);
      return response.varTemp.descripcion??'';
    }catch(err){
      return '';
    }
  }
  async getVariable(
    idVariable: string,
    idEvaluacion: number
  ){
    try{
      const response = await this.service.getVariable(idEvaluacion, idVariable);
      return response.detalleEvaluacionVariable.valor??'';
    }catch(err){
      return '';
    }
  }

  async getRiesgos(idInstitucion: string, mes: number, an: number){
    try{
      const response = await this.service.getGAPRiesgos(idInstitucion, mes, an);
      return response;
    }catch(err){
      if (this.esErrorDeConexion(err)) {
        // this.recargarTablero();
        return;
      }

      console.error(err);
    }
  }

  private esErrorDeConexion(error: any): boolean {
    const mensaje = error?.message ?? '';

    return (
      mensaje.includes('ERR_CONNECTION_TIMED_OUT') ||
      mensaje.includes('Failed to fetch') ||
      mensaje.includes('NetworkError')
    );
  }
}

